/* eslint-disable no-case-declarations */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/camelcase */
/* globals angular $ */
import CONSTANTS from '~/constants'

import tplText from './templates/text'
import tplHeader from './templates/header'
import tplBlockquote from './templates/block_quote'
import tplImage from './templates/image'
import tplGallery from './templates/gallery'
import tplVideo from './templates/video'
import tplCode from './templates/code'
import tplRawHtml from './templates/raw_html'
import tplReference from './templates/reference'
import tplInterstitialLink from './templates/instertitial_link'
import tplList from './templates/list'
import tplTable from './templates/table'
import tplCorrection from './templates/correction'
import tplOembedResponse from './templates/oembed_response'
import tplLoadFailure from './templates/load_failure'
import tplStory from './templates/story'
import tplQuote from './templates/quote'
import tplQuote2 from './templates/quote2'
import tplNumericRating from './templates/numeric_rating'
import tplUnknown from './templates/unknown'

function contentTemplates($http, $q, $rootScope, featureFlagService) {
  /* BASIC CONTENT ELEMENT STRUCTURE

    baseContentTemplates.[ANS_TYPE_STRING] : Object [required] - Describes a feature in ANS.
        template : STRING [required] - The html markup that appears in the editor. model = $scope.feature
        propertyTemplate : STRING [optional] - The html markup that appears in the property panel. model = $scope.feature
        initialInflation : function [optional] - A function that returns an object [optional] : Sets defaults when new elements are created
        onPaste: function [optional] - called when paste event detects the element type. Returns ANS object
        interfaceApi - STRING [optional] - When set, iframe loads URL for 3rd party integration.
        preview - function [optional] - called when the feature's preview button is clicked
        setIds - function [optional] - Helper method that allows the id method to determine what children elements need ids.
  */
  let baseContentTemplates = {}
  featureFlagService
    .instance()
    .then((featureFlag) => {
      const urlPath = '/v2/oembed/'
      const oEmbedUrl = `'${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}${urlPath}' + storyid + '/' + feature._id`

      baseContentTemplates = {
        text: tplText,
        header: tplHeader,
        blockquote: tplBlockquote,
        image: tplImage,
        gallery: tplGallery,
        video: tplVideo,
        code: tplCode,
        raw_html: tplRawHtml,
        reference: tplReference(oEmbedUrl),
        interstitial_link: tplInterstitialLink,
        list: tplList,
        table: tplTable,
        correction: tplCorrection,
        // DEAL WITH REVISION
        oembed_response: tplOembedResponse(oEmbedUrl),
        loadFailure: tplLoadFailure,
        // We do not support this in the toolbox items yet, but some imported stories have this.
        story: tplStory,
        quote: tplQuote,
        quote2: tplQuote2,
        numeric_rating: tplNumericRating,
        // Endorsement should be handled by the same rating logic
        endorsement: tplNumericRating,
        unknown: tplUnknown,
      }
    })
    .catch((err) => {
      throw err // TODO: review how to throw errors on composer
    })

  $rootScope.$on('DISPATCH', (_, action) => {
    if (action.type !== 'HANDLE_COMMANDS') {
      return
    }

    if (action.sub_type === 'show-all') {
      const activeFeature = angular.element('.feature-focused')
      const cm = activeFeature.find('.CodeMirror')
      cm.toggleClass('showAll')
      const btn = activeFeature.find('.btnShowAll')
      btn.toggleClass('fa-caret-square-o-up fa-caret-square-o-down')
    }

    const activeCell = angular.element(document.activeElement).closest('td, th')
    if (activeCell.length) {
      switch (action.sub_type) {
        case 'insert-column-left':
        case 'insert-column-right':
          const dir = action.sub_type === 'insert-column-left' ? 0 : 1
          const insertCol = activeCell.index() + dir

          if (action.feature.header) {
            action.feature.header.splice(insertCol, 0, {
              content: '',
              type: 'text',
            })
          }

          action.feature.rows.forEach((row) => {
            row.splice(insertCol, 0, { content: '', type: 'text' })
          })

          break
        case 'delete-column':
          if (action.feature.rows[0].length > 1) {
            if (action.feature.header) {
              action.feature.header.splice(activeCell.index(), 1)
            }

            action.feature.rows.forEach((row) => {
              row.splice(activeCell.index(), 1)
            })
          }

          break
        case 'insert-row-above':
        case 'insert-row-below':
          // action.feature.rows.
          const rowDir = action.sub_type === 'insert-row-above' ? 0 : 1
          const currentIndex = activeCell.parent('tr').index()
          const insertRow = currentIndex + rowDir
          const numCols = action.feature.rows[currentIndex].length
          const rowDetails = Array(numCols).map(() => {
            return { type: 'text', content: '' }
          })

          if (activeCell.is('td')) {
            action.feature.rows.splice(insertRow, 0, rowDetails)
          }
          break
        case 'delete-row':
          const currentRow = activeCell.parent('tr')
          if (activeCell.is('td') && currentRow.siblings().length) {
            action.feature.rows.splice(currentRow.index(), 1)
          }
          break
      }
    }
  })

  window.addEventListener(
    'message',
    function (resp) {
      if (resp.data && resp.data[0] === 'oembed_resize') {
        const id = resp.data[1]
        const height = resp.data[2]
        $(`[data-oid="${id}"]`).height(height)
        const feature = $(`[data-oid="${id}"]`).parent()
        const cover = feature.find('.cover')
        cover.width(feature.width())
        cover.height(feature.height())
      }
    },
    false
  )

  this.hasPropertyTemplate = (type) =>
    !!(baseContentTemplates[type] || {}).propertyTemplate

  this.get = function (type) {
    return baseContentTemplates[type] || baseContentTemplates.unknown
  }

  this.getTemplate = function (type) {
    return (baseContentTemplates[type] || baseContentTemplates.unknown).template
  }

  this.getApiService = function (type) {
    return baseContentTemplates[type] && baseContentTemplates[type].interfaceApi
  }

  this.getOnPasteConversion = function (type, elem) {
    const temp = baseContentTemplates[type]
    const pasted = temp.onPaste ? temp.onPaste(elem) : null
    return pasted
  }

  this.getPreview = function (type) {
    return (baseContentTemplates[type] || baseContentTemplates.unknown).preview
  }

  this.getProperties = function (type) {
    return (baseContentTemplates[type] || baseContentTemplates.unknown)
      .propertyTemplate
  }

  this.getInitialInflation = function (type) {
    const fnc = (baseContentTemplates[type] || baseContentTemplates.unknown)
      .initialInflation
    return fnc ? fnc() : null
  }

  this.setIdsMethod = function (type) {
    const fnc = (baseContentTemplates[type] || baseContentTemplates.unknown)
      .setIds
    return fnc || null
  }

  this.beforeSaveMethod = function (type) {
    const fnc = (baseContentTemplates[type] || baseContentTemplates.unknown)
      .beforeSave
    return fnc || null
  }

  this.getConvertableTemplates = (settings) => {
    const convList = Object.keys(baseContentTemplates).filter(
      (key) => baseContentTemplates[key].convertable
    )
    const oSettings = settings || window.org_settings
    const toolsOrder = oSettings && oSettings.tools
    if (toolsOrder) {
      return toolsOrder.reduce((opts, type) => {
        if (convList.indexOf(type) > -1) {
          opts.push(baseContentTemplates[type])
        }
        return opts
      }, [])
    }
    return []
  }
}

export default [
  '$http',
  '$q',
  '$rootScope',
  'featureFlagService',
  contentTemplates,
]
